<template>
  <div
    class="d-flex align-center justify-space-between px-4"
    :style="route.name !== 'homePage' ? `margin-bottom: 0px` : `margin-bottom: 87px`"
  >
    <!-- 目前在 editComponent 頁面，才顯示返回「我的元件」按鈕 -->
    <v-btn
      v-if="route.name === 'editComponent'"
      variant="text"
      prepend-icon="mdi-chevron-left"
      :disabled="share_status"
      @click="router.push({ path: '/my_component', query: { organizationId: route.query.organizationId } })"
    >
      <template v-slot:prepend>
        <v-icon></v-icon>
      </template>
      返回「我的元件」
    </v-btn>

    <v-btn
      v-else-if="route.name !== 'homePage'"
      variant="text"
      prepend-icon="mdi-chevron-left"
      :disabled="share_status"
      @click="router.push('/')"
    >
      <template v-slot:prepend>
        <v-icon></v-icon>
      </template>
      回首頁
    </v-btn>

    <!-- 公開元件搜尋 -->
    <div
      class="d-none d-lg-block"
      style="width: 785px"
      v-if="route.name === 'searchComponent'"
    >
      <v-row>
        <v-col cols="4">
          <v-radio-group
            v-model="searchMode"
            hide-details
            inline
            :disabled="share_status"
          >
            <v-radio
              color="primary"
              label="關鍵字"
              value="queryByKeyword"
            ></v-radio>
            <v-radio
              color="primary"
              label="xObject ID"
              value="getxObjectsWithOutData"
            ></v-radio>
          </v-radio-group>
        </v-col>

        <v-col cols="8">
          <v-text-field
            rounded
            hide-details
            append-inner-icon="mdi-magnify"
            placeholder="請輸入廠牌/型號/類型/或其他關鍵字..."
            density="compact"
            variant="outlined"
            v-model="searchData"
            :disabled="share_status"
            @keypress.enter.prevent="searchValue()"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>

    <!-- 私有元件搜尋 -->
    <div
      style="width: 300px; 
      margin-left: auto;"
      class="mr-2"
      v-if="route.name === 'myComponent'"
    >
      <v-text-field
        :label=myComponentSearchLabel
        rounded
        density="compact"
        variant="outlined"
        hide-details
        clearable
        append-inner-icon="mdi-magnify"
        v-model="myComponentKeyword"
        @keypress.enter.prevent="searchValue()"
        @click:append-inner="searchValue()"
        @click:clear="clearSearch()"
      ></v-text-field>
    </div>

    <div
      v-if="tokenValid"
      :class="{ 'ml-auto': route.name === 'homePage' }"
    >
      <v-btn
        variant="text"
        :disabled="share_status"
        v-if="route.name !== 'myComponent' && route.name !== 'editComponent'"
        @click="routerPush('/my_component')"
      >我的元件</v-btn>

      <v-btn
        icon="mdi-heart-outline"
        variant="text"
        :disabled="share_status"
        @click="router.push('/commonly_used_components')"
      ></v-btn>

      <v-btn
        v-if="isRevit && tokenValid"
        icon="mdi-cart"
        variant="text"
        :disabled="share_status"
        @click="router.push('/export_list')"
      ></v-btn>
    </div>

    <div
      :class="{ 'ml-auto': route.name === 'homePage' }"
      v-else
    >
      <v-btn
        variant="text"
        @click="goLogin()"
      >登入/註冊</v-btn>
    </div>
  </div>

  <div
    class="d-flex d-lg-none flex-column px-4"
    v-if="route.name === 'searchComponent'"
  >
    <v-text-field
      rounded
      hide-details
      append-inner-icon="mdi-magnify"
      placeholder="請輸入廠牌/型號/類型/或其他關鍵字..."
      density="compact"
      variant="outlined"
      v-model="searchData"
      :disabled="share_status"
      @keypress.enter.prevent="searchValue()"
    ></v-text-field>

    <div class="d-flex align-center">
      <v-btn
        icon="mdi-menu"
        variant="text"
        @click="filterMenuSwitch = !filterMenuSwitch"
      ></v-btn>

      <v-radio-group
        v-model="searchMode"
        :disabled="share_status"
        hide-details
        inline
      >
        <v-radio
          color="primary"
          label="關鍵字"
          value="queryByKeyword"
        ></v-radio>
        <v-radio
          color="primary"
          label="xObject ID"
          value="getxObjectsWithOutData"
        ></v-radio>
      </v-radio-group>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";

import xObjectStore from "code-library/store/xObject.js";
import { storeToRefs } from "pinia";
import axiosAPIStore from "code-library/store/axiosAPI.js";
import searchComponentStore from "@/store/searchComponent.js";
import navbarButtonStore from "@/store/navbarButton.js";
import routerListStore from "@/store/routerList.js";

// -----------------------------------------------------------

import sharedComponentsStore from "@/store/sharedComponents.js";

const xObject = xObjectStore();
const router = useRouter();
const route = useRoute();
const axiosAPI = axiosAPIStore();
const searchComponent = searchComponentStore();
const navbarButton = navbarButtonStore();
const routerList = routerListStore();
const sharedComponents = sharedComponentsStore();

//state
const { filterData, searchKeyWords } = storeToRefs(xObject);
const { tokenValid } = storeToRefs(axiosAPI);
const { showCardData, loading, searchData, searchMode, showNoDataText } = storeToRefs(
  searchComponent
);
// const { filterMenuSwitch } = storeToRefs(navbarButton);
const { share_status } = storeToRefs(sharedComponents);
const { filterMenuSwitch, myComponentSearchLabel } = storeToRefs(navbarButton);

//action
const { getCookieByName, setCookieByName, checkTokenStatus } = axiosAPI;
const { saveSearchKeyWords, queryByKeyword, getxObjectsWithOutData } = xObject;
const { markCommonComponents } = searchComponent;
const { routerPush } = routerList;

// --------------------------------------------------------------------
const localStorageSearchData = localStorage.getItem("searchKeyWords");

// const searchData = searchKeyWords;

// 搜尋私有元件關鍵字
const myComponentKeyword = ref("");

const isRevit = ref(false);

onMounted(async () => {
  tokenValid.value = await checkTokenStatus();
  // searchData.value = localStorageSearchData;
  //判斷是否從Revit登入
  // const getRevitJudge = localStorage.getItem("wvUserLoginMode") || null;
  const getRevitJudge = getCookieByName("wvUserLoginMode") || null;

  isRevit.value = getRevitJudge === "1";
});

// 搜尋
async function searchValue() {
  console.log("searchMode初始", searchMode.value);
  // myComponent 固定走 keyword 搜尋
  if (route.name === "myComponent") {
    await router.push({
      path: "/my_component",
      query: { keyword: myComponentKeyword.value },
    });

    return; // 直接結束，不進 switch
  }

  switch (searchMode.value) {

    case "queryByKeyword":
      await router.push({
        path: "/search_component",
        query: { keyword: searchData.value },
      });
      break;
    case "getxObjectsWithOutData":
      await router.push({
        path: "/search_component",
        query: {
          xObjectId: searchData.value,
        },
      });
      break;
  }

  if (route.name === "searchComponent") {
    window.location.reload();
  }
}

// 在"我的元件"頁 清除搜尋
async function clearSearch() {
  myComponentKeyword.value = "";
  await router.push({
    path: "/my_component",
  });
}

// 前往 登入/註冊
function goLogin() {
  localStorage.setItem("path", window.location.href);
  // document.cookie = 'path=' + window.location.href + ';domain=.mindlogic.com.tw;max-age=2592000;path=/;';
  setCookieByName("path", window.location.href);

  window.location.href = `${process.env.VUE_APP_LOGIN}`;
}

</script>
